import Store from '@ember-data/store';
import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export default class MailchimpRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;
  @service declare store: Store;

  beforeModel() {
    // forcing everyone to the new mailchimp sync
    this.router.transitionTo('funds.fund.more.mailchimp-sync');
    return;
  }

  async model() {
    let mailchimpSetting = (
      await this.store.query('mailchimp-setting', {})
    ).slice()[0];
    let firstMailchimpFundSettingFundId =
      mailchimpSetting?.fundSettings?.slice()?.[0]?.fundId;
    if (firstMailchimpFundSettingFundId) {
      let firstMailchimpFundSettingFund = await this.store.findRecord(
        'fund',
        firstMailchimpFundSettingFundId,
      );
      return {
        mailchimpSetting,
        firstMailchimpFundSettingFund,
      };
    } else {
      return {
        mailchimpSetting,
      };
    }
  }

  @action
  refreshMailchimpRoute() {
    this.refresh();
  }
}
